export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="rounded-2xl bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 p-8 md:p-12 lg:p-16 flex flex-col lg:flex-row items-center gap-8 lg:gap-12 relative overflow-hidden">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(255,255,255,0.1)_0%,transparent_60%)]"></div>

          <div className="relative flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-background-50 mb-3">
              App下载
            </h2>
            <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-6">
              下载吃瓜视频App，随时随地观看最新国产吃瓜视频。更流畅的体验，更及时的推送，不错过任何一个热点。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button className="w-full sm:w-auto px-8 py-3.5 bg-background-50 text-primary-600 font-bold text-sm rounded-lg hover:bg-background-100 transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-2">
                <i className="ri-apple-fill text-lg"></i>
                App Store 下载
              </button>
              <button className="w-full sm:w-auto px-8 py-3.5 bg-white/20 text-background-50 font-bold text-sm rounded-lg hover:bg-white/30 transition-all cursor-pointer whitespace-nowrap backdrop-blur-sm flex items-center justify-center gap-2">
                <i className="ri-android-fill text-lg"></i>
                Android 下载
              </button>
            </div>
          </div>

          <div className="relative flex-shrink-0">
            <div className="w-48 md:w-56 h-auto aspect-[9/16] rounded-2xl overflow-hidden border-4 border-background-50/20">
              <div className="w-full h-full bg-background-950/40 backdrop-blur-sm flex flex-col items-center justify-center p-4">
                <div className="w-10 h-10 rounded-xl bg-primary-500 flex items-center justify-center mb-3">
                  <i className="ri-vidicon-line text-background-50 text-lg"></i>
                </div>
                <span className="text-white font-bold text-sm mb-2">吃瓜视频</span>
                <span className="text-white/60 text-xs">扫一扫下载App</span>
                <div className="mt-3 w-20 h-20 bg-white/90 rounded-lg flex items-center justify-center">
                  <i className="ri-qr-code-line text-foreground-800 text-3xl"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}